module.exports = __webpack_public_path__ + "img/image (4).2dd0bc49.webp";